import { memo, type ReactNode } from "react";

import "./Grid.css";

interface GridProps {
  children?: ReactNode;
  style?: React.CSSProperties;
}

const Grid = ({ children, style }: GridProps) => (
  <div className="grid" style={style}>
    {children}
  </div>
);

Grid.defaultProps = {
  children: undefined,
  style: undefined,
};

interface GridItemProps {
  children?: ReactNode;
  style?: React.CSSProperties;
}

export const GridItem = ({ children, style }: GridItemProps) => (
  <div className="grid-item" style={style}>
    {children}
  </div>
);

GridItem.defaultProps = {
  children: undefined,
  style: undefined,
};

export default memo(Grid);
